import { Megaphone } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminSponsored() {
  return (
    <CollectionAdmin
      path="sponsored"
      title="Sponzorirani sadržaj"
      subtitle="Plaćeni članci i nativni oglasi"
      icon={Megaphone}
      testid="admin-sponsored"
      fields={[
        { key: 'title', label: 'Naslov' },
        { key: 'advertiser', label: 'Oglašivač' },
        { key: 'article_slug', label: 'Slug članka' },
        { key: 'start_date', label: 'Početak (ISO)' },
        { key: 'end_date', label: 'Kraj (ISO)' },
        { key: 'amount_eur', label: 'Iznos (EUR)', type: 'number' },
        { key: 'status', label: 'Status (draft/live/expired)' },
      ]}
    />
  );
}
